export const radioOptions = [
  { label: 'Municípios', value: 'MUNICIPIO' },
  { label: 'Macrorregiões', value: 'MACRORREGIAO' }
];
